// extracted by mini-css-extract-plugin
module.exports = {"container":"help-and-support-cta_container__IA0eE","linkLabel":"help-and-support-cta_linkLabel__XRL8N","linkIcon":"help-and-support-cta_linkIcon__wT6_1"};